// Libraries
import React, { forwardRef } from 'react';
import classNames from 'classnames';

const Textarea = forwardRef(({ className, ...props }, ref) => (
  <textarea className={classNames(className, 'textarea')} {...props} ref={ref} />
));

export default Textarea;
